import React from 'react';
import PropTypes from 'prop-types';
import {
  Typeform,
} from '@minerva-analytics/pantheon';
import {
  TypeformContainer,
  ConfirmationSubtext,
  ConfirmationFormTitle,
} from './SignUpOnPageJump.styles';

const SignUpOnPageJump = (props) => {
  const { email } = props;
  return (
    <>
      <ConfirmationFormTitle>Thanks! We just sent you a confirmation email.</ConfirmationFormTitle>
      <ConfirmationSubtext>
        Please check your inbox for a message from Starguide
        to confirm your email.
        Don&apos;t forget to check your junk folder - just in case!
      </ConfirmationSubtext>
      <TypeformContainer>
        <Typeform formID="m1aqWQE1" parameters={{ email }} />
      </TypeformContainer>
    </>
  );
};

SignUpOnPageJump.propTypes = {
  email: PropTypes.string,
};

export default SignUpOnPageJump;
